import { render, staticRenderFns } from "./UpdateVoucherImageComponent.vue?vue&type=template&id=03853c0c&"
import script from "./UpdateVoucherImageComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateVoucherImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports